var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22.49,
    viewBox: "0 0 26 22.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b{fill:#2fffd1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.254 1.094)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.339,4.778a6.1,6.1,0,0,1,8.644,0l1.16,1.2,1.2-1.2a6.111,6.111,0,1,1,8.625,8.66L21.786,14.6l-8.644,8.624L4.535,14.6l-1.2-1.16A6.156,6.156,0,0,1,3.339,4.778Z",
    transform: "translate(-1.559 -2.984)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.531,4.972a6.764,6.764,0,0,1,9.578,0L14.395,6.3,15.72,4.972a6.772,6.772,0,0,1,9.558,9.6l-1.305,1.285-9.578,9.556L4.857,15.853,3.531,14.568A6.821,6.821,0,0,1,3.531,4.972Z",
    transform: "translate(-1.559 -2.984)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteSelected);
export default __webpack_public_path__ + "static/media/favorite_selected.f2bac882a3ab85b28d0c0c505750e973.svg";
export { ForwardRef as ReactComponent };